import { forwardRef, useState, useRef, useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';

import { format } from 'date-fns';
import dateUtils, { DEFAULT_DATE_FORMAT } from '@plannel/utils/date-util';

import 'react-datepicker/dist/react-datepicker.css';
import CodeUtil from '@plannel/pages/utils/code-util';

const GridDatePicker = forwardRef((props, ref) => {
  let dateType = props.column.colDef.cellEditorParams.dateType;
  let startDay = props.column.colDef.cellEditorParams.startDay;
  let isFirstDay = props.column.colDef.cellEditorParams.isFirstDay;
  let bucket = props.column.colDef.cellEditorParams.bucket;
  let isStart = props.column.colDef.cellEditorParams.isStart;
  const maxDate = props.column.colDef.cellEditorParams?.maxDate;
  const minDate = props.column.colDef.cellEditorParams?.minDate;
  const { popupGrid = false } = props.column.colDef.cellEditorParams;

  if (!dateType) {
    dateType = props.dateType;
    startDay = props.startDay;
    isFirstDay = props.isFirstDay;
    bucket = props.bucket;
    isStart = props.isStart;
  }
  const refDatePicker = useRef();
  const dateValue = new ZDate(props.value ? props.value : "");
  const [date, setDate] = useState(dateUtils.dateValidation(dateValue) ? dateValue : "");
  const [editing, setEditing] = useState(true);
  const [dateFormat, setDateFormat] = useState("yyyy-MM-dd");
  const [showMonthYear, setShowMonthYear] = useState(false);
  const [showYear, setShowYear] = useState(false);
  const [showTime, setShowTime] = useState(false);

  const isWeekday = (localDate) => {
    const day = localDate.getDay();
    if (bucket === CodeUtil.buckets.PARTIAL_WEEK) {
      if (localDate.getDate() === 1 && isStart) {
        return true;
      }
      if (localDate.getDate() === dateUtils.endOfMonthDate(localDate).getDate() && !isStart) {
        return true;
      }
    }
    if (startDay && dateType === "day") {
      return day === dateUtils.getMyDayId(startDay)
    } else {
      return day === 0 || day === 1 || day === 2 || day === 3 || day === 4 || day === 5 || day === 6;
    }
  };

  const onChange = selectedDate => {
    setDate(selectedDate);
    let formattedValue = "";
    if (selectedDate) {
      if (dateType === "month") {
        if (isFirstDay) {
          formattedValue = format(dateUtils.startOfMonthDate(selectedDate), DEFAULT_DATE_FORMAT);
        } else {
          formattedValue = format(dateUtils.endOfMonthDate(selectedDate), DEFAULT_DATE_FORMAT);
        }
      } else {
        formattedValue = format(selectedDate, DEFAULT_DATE_FORMAT);
      }
    }
    if (props.onValueChange) {
      props.onValueChange(formattedValue);
    }
    setEditing(false);
  };

  const defDateFormat = () => {
    if (dateType === "year") {
      setDateFormat("yyyy");
      setShowYear(true);
      setShowMonthYear(false);
    }

    if (dateType === "month") {
      setDateFormat("yyyy-MM");
      setShowYear(false);
      setShowMonthYear(true);
    }

    if (dateType === "day") {
      setDateFormat("yyyy-MM-dd");
      setShowYear(false);
      setShowMonthYear(false);
    }

    if (dateType === "time") {
      setDateFormat("yyyy-MM-dd HH:mm");
      setShowYear(false);
      setShowMonthYear(false);
      setShowTime(true);
    }
  };

  useEffect(() => {
    if (!editing) {
      props.api.stopEditing();

      refDatePicker.current.setOpen(false);
    } else {
      refDatePicker.current.setOpen(true);
    }

    defDateFormat();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing]);

  return (
    <ReactDatePicker
      portalId={popupGrid ? 'grid-datepicker-popup' : 'grid-datepicker'}
      ref={refDatePicker}
      popperClassName="ag-custom-component-popup"
      selected={date === "" ? null : date}
      dateFormat={dateFormat}
      onChange={onChange}
      filterDate={isWeekday}
      minDate={minDate}
      maxDate={maxDate}
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      showMonthYearPicker={showMonthYear}
      showYearPicker={showYear}
      showTimeSelect={showTime}
      customInput={<input className="grid-date-picker-input" />}
    />
  );
});

export default GridDatePicker;
